module.exports = __webpack_public_path__ + "edd67b787dfa0792e9e2c8b16c43c543.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/owlidays-cup-s.png
// module id = 2570
// module chunks = 0